import { PropsWithChildren } from 'react';
import { useTheme } from './hooks/useStore';
import { dark, light } from './styles/css/theme.css';

const ThemeProvider = ({ children }: PropsWithChildren) => {
  const theme = useTheme();

  const className = (() => {
    switch (theme) {
      case 'dark':
        return dark;
      case 'light':
        return light;
    }
  })();

  return <div className={className}>{children}</div>;
};

export default ThemeProvider;
